import { Injectable } from '@angular/core';

import { BetSlipType } from '@bpos';
import { LDFeatureFlags, LaunchDarklyFlagManagerService } from 'packages/sports/web/app/src/bootstrap/launch-darkly-flag-manager.service';

import { IPlacedBetslipResult } from '../../betplacement/models';
import { isSucceededNonPartialSlip } from '../../betplacement/utils';

@Injectable()
export class BetslipLaunchDarklyTrackingService {
    private readonly ldBetslipModeFlag = LDFeatureFlags.DisplayMode;
    private readonly ldBetPlacementTest = 'BetPlacement';
    private readonly ldLegsPerMultiTest = 'LegsPerMulti';

    constructor(private ldFlagManagerService: LaunchDarklyFlagManagerService) {}

    trackSucceededSlips(result: IPlacedBetslipResult): void {
        const slips = result.slips.filter((slip) => isSucceededNonPartialSlip(slip));
        const comboSlip = slips.filter((slip) => slip.betType === BetSlipType.Combo)[0];
        const legsPerCombo = comboSlip?.picks.length;

        this.ldFlagManagerService.track(this.ldBetslipModeFlag, this.ldBetPlacementTest, slips.length);
        this.ldFlagManagerService.track(this.ldBetslipModeFlag, this.ldLegsPerMultiTest, legsPerCombo ?? 0);
    }
}
